import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useUIStore } from '@/core/stores/ui.store';
import { useToast } from '@/shared/hooks/useToast';
import { projectsService } from '../api/projects.service';
import { PROJECT_KEYS } from './queryKeys';

export function useDeleteProject() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('projects');
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  const setSelectedProjectId = useUIStore((s) => s.setSelectedProjectId);

  return useMutation({
    mutationFn: (projectId: string) => projectsService.delete(projectId),
    onSuccess: (_data, deletedId) => {
      queryClient.invalidateQueries({ queryKey: PROJECT_KEYS.byOrg(orgId ?? '') });
      queryClient.removeQueries({ queryKey: PROJECT_KEYS.detail(orgId ?? '', deletedId) });
      setSelectedProjectId(null);
      toast.success({ title: t('toast.deleted') });
    },
  });
}
